import { useEffect } from "react";

/**
 * Ripristina eventuali blocchi di scorrimento rimasti orfani dopo la
 * chiusura di un layer Radix. Durante un layer realmente aperto non
 * modifica nulla: il blocco del body serve allo scroll interno del modale.
 */
export default function usePageScrollSafety(activePage) {
  useEffect(() => {
    let timer = null;

    const hasOpenLayer = () =>
      Boolean(
        document.querySelector(
          [
            '[role="dialog"][data-state="open"]',
            '[role="menu"][data-state="open"]',
            '[role="listbox"][data-state="open"]',
          ].join(",")
        )
      );

    const releaseOrphanedLock = () => {
      timer = null;
      if (hasOpenLayer()) return;

      const body = document.body;
      const root = document.documentElement;

      body.removeAttribute("data-scroll-locked");
      body.style.removeProperty("pointer-events");
      body.style.removeProperty("overflow");
      body.style.removeProperty("padding-right");
      root.style.removeProperty("overflow");
      root.style.removeProperty("padding-right");
    };

    const scheduleCheck = () => {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(releaseOrphanedLock, 350);
    };

    const observer = new MutationObserver(scheduleCheck);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["style", "data-scroll-locked"],
      childList: true,
      subtree: true,
    });

    window.addEventListener("pageshow", scheduleCheck);
    scheduleCheck();

    return () => {
      observer.disconnect();
      window.removeEventListener("pageshow", scheduleCheck);
      if (timer) window.clearTimeout(timer);
    };
  }, [activePage]);
}
